import {useContext, useEffect, useReducer} from 'react'
import {jwtDecode} from 'jwt-decode'
import axios from 'axios'
import {useNavigate} from 'react-router'
import LoginFormReducer from '../reducers/LoginFormReducer'
import AuthAPI from '../services/AuthAPI'
import AuthContext from '../contexts/AuthContext'
import {TokenManager} from './TokenManager'
import {useStoreExecutions} from "../store/useStoreExecutions";
import {anonymizeEmail} from '../Tools/String.ts'

export function useLogin(location, impersonate) {
  const {setIsAuthenticated, setUser} = useContext(AuthContext)
  const navigate = useNavigate()
  let referer = location ? location.state.referer : '/tableau-de-bord'
  const source = axios.CancelToken.source()
  const hasFlowerFeast =
    sessionStorage.getItem('flower_feast') === 'true' ||
    sessionStorage.getItem('flower_feast') > 0
  const setFlorist = useStoreExecutions(state => state.setFlorist);

  if (hasFlowerFeast) {
    referer = '/executions'
  }

  // Etat par défaut
  const [state, dispatch] = useReducer(LoginFormReducer, {
      isError: false,
      isLoading: false,
      errorMessage: false,
      errorField: false,
      modalShow: false,
      credentials: {
          codefl: '',
          password: '',
          username: ''
      },
      impersonation: false,
  })

  // Gestion des champs
  function handleChange({currentTarget}) {
      const {value, name} = currentTarget
      dispatch({
          type: 'HANDLE_CHANGE',
          credentials: {...state.credentials, [name]: value}, // La clé name dans crédentials ancien état change par value
      })
  }


  function initCredentials({codefl, username}: {codefl?: string, username?: string}) {
    dispatch({
        type: 'HANDLE_CHANGE',
        credentials: {
          codefl: codefl ?? '',
          username: username ?? ''
        },
    })
  }

  async function fetchLogin() {
    dispatch({
      type: 'FETCH_INIT',
    })

    try {
        const results = await AuthAPI.authenticate(state.credentials, impersonate)
        dispatch({
        type: 'FETCH_SUCCESS',
        })

        if (String(results.data.code) === 'update_password_requested') {
            navigate('/changement-mot-de-passe-information');
            sessionStorage.setItem('email', anonymizeEmail(results.data.email));
        } else {
            const tokenManager = TokenManager()
            tokenManager.setToken(results.data.token)
            setUser(jwtDecode(results.data.token)) // On save le user dans le contexte
            setFlorist(jwtDecode(results.data.token))
            setIsAuthenticated(true)
            sessionStorage.removeItem('flower_feast')
            navigate(referer) // Redirection
        }
    } catch (error) {
      if (error.response && error.response.data.message === 'Bad credentials') {
        dispatch({
          type: 'FETCH_ERROR_BAD_CREDENTIALS',
        })
      } else {
        dispatch({
          type: 'FETCH_ERROR',
          errorMessage: error.message,
        })
      }
    }
  }

  // Gestion du submit
  async function handleSubmit(event) {
    event.preventDefault()
    fetchLogin()
  }

  // gestion de la modal du formulaire de demande d'adhésion.
  function handleSubscriptionModal(active = false) {
    dispatch({
      type: 'FETCH_SUBSCRIPTION_MODAL',
      modalShow: active,
    })
  }

  useEffect(() => {
    return () => {
      source.cancel('Component LoginForm is unmounted')
    }
  }, [])

  return {state, dispatch, initCredentials, handleChange, handleSubmit, handleSubscriptionModal}
}
